import React, { useState } from "react"
import { Card, CardBody } from "reactstrap"
import { useClientContext } from "../ClientContextBox"
import LoadingButton from "components/Common/LoadingButton"
import { axiosbaseurl } from "configure"
import { app_url, fixedIds } from "app_config"
import { useNavigate } from "react-router-dom"

const PracticeResponsibility = ({ changeStep, client_id, setHasPractice }) => {
  const {
    isReadOnly,
    staff_options,
    practice_options,
    clientName,
    clientUnderPractice,
    setClientUnderPractice,
    clientManager,
    setClientManager,
    productionManager,
    setProductionManager,
    assistant,
    setAssistant,
    administrator,
    setAdministrator,
    cisManager,
    setCisManager,
    payrollManager,
    setPayrollManager,
    servicesCalculation,
    clientId,
    errors,
    setErrors,

    setIsChanged,
  } = useClientContext()

  const [loading, setLoading] = useState(false)

  const navigate = useNavigate()

  const validate = () => {
    let tempErrors = {}

    if (!clientUnderPractice)
      tempErrors.clientUnderPractice = "Client Under Practice is required."

    if (!clientManager) tempErrors.clientManager = "Client Manager is required."
    if (!productionManager)
      tempErrors.productionManager = "Production Manager is required."
    if (!assistant) tempErrors.assistant = "Assistant is required."
    if (!administrator) tempErrors.administrator = "Administrator is required."

    // if (servicesCalculation?.find(i => i.id == fixedIds.cis)?.isChecked)
    //   if (!cisManager) tempErrors.cisManager = "CIS Manager is required."

    // if (servicesCalculation?.find(i => i.id == fixedIds.payroll)?.isChecked)
    //   if (!payrollManager)
    //     tempErrors.payrollManager = "Payroll Manager is required."

    setErrors(tempErrors)
    return Object.keys(tempErrors).length === 0
  }

  const handleSubmit = async () => {
    if (validate() && !isReadOnly) {
      // if (true) {
      swal({
        title: "Are you sure?",
        text: `You want to save this details to ${clientName}.`,
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then(async willDelete => {
        if (willDelete) {
          try {
            setLoading(true)

            const post_data = {
              clientUnderPracticeId: clientUnderPractice,
              clientManagerId: clientManager,
              productionManagerId: productionManager,
              assistantId: assistant,
              administratorId: administrator,
              CISManagerId: cisManager,
              payrollManagerId: payrollManager,
            }

            const response = await axiosbaseurl.put(
              `/client/assigned-employee/${clientId || client_id}`,
              post_data
            )

            if (response.data.success) {
              // setClientId(response.data.data.id)
              setIsChanged(prev => ({ ...prev, 5: false }))

              setHasPractice(true)
              swal("", "Details saved successfully", "success").then(() => {
                if (!client_id) {
                  // navigate(`${app_url}clients`)
                  changeStep(1)
                }
              })
            }
          } catch (error) {
            console.log(error)
            const msg =
              error.response.data.message ||
              error.message ||
              "Something went Wrong"

            swal(
              "",
              msg,
              msg.includes("No changes were made !") ? "warning" : "error"
            )
          } finally {
            setLoading(false)
          }
        }
      })
    } else {
      window.scrollTo(0, 0)
    }
  }

  function getStaff(type) {
    if (staff_options?.length)
      try {
        return staff_options?.filter(item => {
          if (item.designation)
            return JSON.parse(item.designation)?.includes(type)
        })
      } catch (error) {
        console.error(error)
      }
  }

  return (
    <div>
      <Card>
        <CardBody>
          <div className="row mb-2">
            <h4 className="fw-bold mb-4">Practice Responsibility</h4>
            <div className="col-md-4 mb-3">
              <label>
                Client Under Practice <span className="text-danger">*</span>
              </label>
              <select
                className="form-select input-field"
                disabled={isReadOnly}
                value={clientUnderPractice}
                onChange={e => setClientUnderPractice(e.target.value)}
              >
                <option value="">Select Client Under Practice</option>
                {practice_options
                  ?.slice()
                  .sort((a, b) => a.practiceName.localeCompare(b.practiceName))
                  ?.map(option => (
                    <option key={option.id} value={option.id}>
                      {option.practiceName}
                    </option>
                  ))}
              </select>
              <span className="error">{errors.clientUnderPractice}</span>
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-md-4 mb-3">
              <label>
                Client Manager <span className="text-danger">*</span>
              </label>
              <select
                className="form-select input-field"
                disabled={isReadOnly}
                value={clientManager}
                onChange={e => setClientManager(e.target.value)}
              >
                <option value="">Select Client Manager</option>
                {getStaff("Client Manager")
                  ?.slice()
                  .sort((a, b) =>
                    `${a.name} ${a.lastName}`.localeCompare(
                      `${b.name} ${b.lastName}`
                    )
                  )
                  .map(option => (
                    <option key={option.id} value={option.id}>
                      {`${option.name} ${option.lastName}`}
                    </option>
                  ))}
              </select>
              <span className="error">{errors.clientManager}</span>
            </div>

            <div className="col-md-4 mb-3">
              <label>
                Production Manager <span className="text-danger">*</span>
              </label>
              <select
                className="form-select input-field"
                disabled={isReadOnly}
                value={productionManager}
                onChange={e => setProductionManager(e.target.value)}
              >
                <option value="">Select Production Manager</option>
                {getStaff("Production Manager")
                  ?.slice()
                  .sort((a, b) =>
                    `${a.name} ${a.lastName}`.localeCompare(
                      `${b.name} ${b.lastName}`
                    )
                  )
                  ?.map(option => (
                    <option
                      key={option.id}
                      value={option.id}
                    >{`${option.name} ${option.lastName}`}</option>
                  ))}
              </select>
              <span className="error">{errors.productionManager}</span>
            </div>

            <div className="col-md-4 mb-3">
              <label>
                Assistant <span className="text-danger">*</span>
              </label>
              <select
                className="form-select input-field"
                disabled={isReadOnly}
                value={assistant}
                onChange={e => setAssistant(e.target.value)}
              >
                <option value="">Select Assistant</option>
                {getStaff("Assistant")
                  ?.slice()
                  .sort((a, b) =>
                    `${a.name} ${a.lastName}`.localeCompare(
                      `${b.name} ${b.lastName}`
                    )
                  )
                  ?.map(option => (
                    <option
                      key={option.id}
                      value={option.id}
                    >{`${option.name} ${option.lastName}`}</option>
                  ))}
              </select>
              <span className="error">{errors.assistant}</span>
            </div>

            <div className="col-md-4 mb-md-0 mb-3">
              <label>
                Administrator <span className="text-danger">*</span>
              </label>
              <select
                className="form-select input-field"
                disabled={isReadOnly}
                value={administrator}
                onChange={e => setAdministrator(e.target.value)}
              >
                <option value="">Select Administrator</option>
                {getStaff("Administrator")
                  ?.slice()
                  .sort((a, b) =>
                    `${a.name} ${a.lastName}`.localeCompare(
                      `${b.name} ${b.lastName}`
                    )
                  )
                  ?.map(option => (
                    <option
                      key={option.id}
                      value={option.id}
                    >{`${option.name} ${option.lastName}`}</option>
                  ))}
              </select>
              <span className="error">{errors.administrator}</span>
            </div>
            {/* {servicesCalculation.length &&
              servicesCalculation?.find(i => i.id == fixedIds.cis)?.isChecked && (
                <div className="col-md-4 mb-md-0 mb-3">
                  <label>
                    CIS Manager <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select input-field"
                    disabled={isReadOnly}
                    value={cisManager}
                    onChange={e => setCisManager(e.target.value)}
                  >
                    <option value="">Select CIS Manager</option>
                    {getStaff("CIS Manager")?.map(option => (
                      <option
                        key={option.id}
                        value={option.id}
                      >{`${option.name} ${option.lastName}`}</option>
                    ))}
                  </select>
                  <span className="error">{errors.cisManager}</span>
                </div>
              )}

            {servicesCalculation.length &&
              servicesCalculation?.find(i => i.id == fixedIds.payroll)?.isChecked && (
                <div className="col-md-4 mb-md-0 mb-3">
                  <label>
                    Payroll Manager <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select input-field"
                    disabled={isReadOnly}
                    value={payrollManager}
                    onChange={e => setPayrollManager(e.target.value)}
                  >
                    <option value="">Select Payroll Manager</option>
                    {getStaff("Payroll Manager")?.map(option => (
                      <option
                        key={option.id}
                        value={option.id}
                      >{`${option.name} ${option.lastName}`}</option>
                    ))}
                  </select>
                  <span className="error">{errors.payrollManager}</span>
                </div>
              )} */}
          </div>
        </CardBody>
      </Card>
      {!isReadOnly && (
        <Card>
          <CardBody>
            <LoadingButton
              loading={loading}
              btnText="Submit Now"
              icon_2={<i className="fas fa-arrow-right ms-3"></i>}
              handler={handleSubmit}
            />
          </CardBody>
        </Card>
      )}
    </div>
  )
}

export default PracticeResponsibility
